module.exports = __webpack_public_path__ + "static/media/whatIs.6c19cb86.mp3";